import Icon from '@mdi/react';
import { mdiLogout } from '@mdi/js';
import { IBaseIdentityModel } from '@shared/integrations/taf-api/v2/models';
import useApplicationStore from '@my-pages/stores/useApplicationStore.tsx';
import { Link } from '@tanstack/react-router';

const getMemberInitials = (member?: IBaseIdentityModel): string | undefined => {
    const firstInitial = member?.firstName ? member.firstName.substring(0, 1) : '';
    const lastInitial = member?.lastName ? member.lastName.substring(0, 1) : '';
    return (firstInitial + lastInitial).toUpperCase();
};
const MemberBadge = () => {
    const user = useApplicationStore((state) => state.user);
    if (user == null) return <></>;
    
    return (
        <div className='dropdown'>
            <button
                type='button'
                id='dropdown-user'
                className='btn btn-dropdown-user'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
            >
                {getMemberInitials(user)}
            </button>
            <div
                className='dropdown-menu dropdown-menu-right dropdown-menu-md'
                aria-labelledby='dropdown-user'
            >
                <div className='d-flex flex-column py-2 px-4'>
                    <span className='font-size-lg font-weight-semi-bold'>
                        {user?.firstName} {user?.lastName}
                    </span>
                </div>
                <div className='dropdown-divider'></div>
                <Link
                   to={"/logga-ut"}
                    className='dropdown-item'
                >
                    <Icon
                        path={mdiLogout}
                        className='mdi mr-2'
                    />
                    Logga ut
                </Link>
            </div>
        </div>
    );
};

export default MemberBadge;
